module.exports = __webpack_public_path__ + "static/img/title_icon.ee1f66c0.png";